import { render } from "./Banner.vue?vue&type=template&id=fd0ecb54&scoped=true&bindings={}"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=fd0ecb54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fd0ecb54"

export default script